module.exports = __webpack_public_path__ + "static/media/mypacerlogo200.a0fd3545.png";